var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"modal",class:[`modal--${_vm.$options.name}`]},[_c('product-view',{attrs:{"product":_vm.product},on:{"sendCart":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"modal__close btn btn--remove",on:{"click":_vm.close}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }